import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { PetService } from "../../services/PetsService";

export function useCountPets() {
  const { data, isLoading } = useQuery(
    [namesUseQuery?.GET_COUNT_PETS],
    () => PetService.getCountPetsRegisters(),
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return {
    data: data,
    isLoading,
  };
}
